import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { KeyRound } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

const Navigation = () => {
  const { isAuthenticated, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-black/80 backdrop-blur-xl border-b border-white/5">
      <div className="max-w-6xl mx-auto px-4 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3" data-testid="nav-logo">
          <img src="/med-logo.png" alt="Mediterranean Club" className="h-8 w-8 object-contain" />
          <span className="font-display text-white text-lg font-bold hidden sm:block">Mediterranean Club</span>
        </Link>
        <div className="flex items-center gap-4">
          {isAuthenticated ? (
            <>
              <Link to="/admin" className="text-white/50 hover:text-white text-xs font-semibold tracking-wider uppercase transition-colors" data-testid="nav-admin">
                Admin
              </Link>
              <button
                onClick={() => { navigate('/'); setTimeout(logout, 50); }}
                className="text-white/30 hover:text-[#E91E8D] text-xs transition-colors"
                data-testid="nav-logout"
              >
                Logout
              </button>
            </>
          ) : (
            <Link
              to="/login"
              className="p-2 rounded-lg text-white/25 hover:text-[#E91E8D] hover:bg-white/5 transition-all"
              title="Admin"
              data-testid="nav-admin-icon"
            >
              <KeyRound size={16} />
            </Link>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
